<template>
  <el-row v-loading="loading">
 <el-row class="padding_5px_top">
   <el-tabs
        id="rankingTab"
        v-model="activeTabLevl1"       
      >
      <el-tab-pane v-for="(item,index) in categories" :key="index" :name="`l1-${index}`">
        <span slot="label">{{item.name}} <i class="el-icon-arrow-down"></i></span>
        <el-tabs
            id="subRankingTab"
            v-model="activeTabLevl2[index]"
          >
          <template v-for="(item2, index2) in item.categories">
            <el-tab-pane :label="item2.name" :name="`l2-${index2}`"></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
          </template>
        </el-tabs>
      </el-tab-pane>
      </el-tabs>

    </el-row>

    <div class="line"></div>

    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'PriceDate', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial"
    >

      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="110"
      >
      </el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="legalName"
        label="基金名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立日期"
        min-width="120"
        sortable="custom"
      >
        <template slot-scope="scope">{{ scope.row.inceptionDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="priceDate"
        label="净值日期"
        min-width="120"
        sortable="custom"        
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ scope.row.priceDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="nav"
        label="单位净值|(元)"
        min-width="120"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.nav | fillNullRound4 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="returnYTD"
        label="今年以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnYTD | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnYTD)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="return1Week"
        label="最近一周|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Week | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Week)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="return1Month"
        label="最近一月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return3Month"
        label="最近三月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return3Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return6Month"
        label="最近六月|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return6Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return6Month)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return1Year"
        label="最近一年|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Year)">%</span>
        </template>
      </el-table-column>

      <el-table-column
        label="最近两年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return2Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn2Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn2Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近三年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return3Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn3Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn3Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return5Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn5Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn5Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近七年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return7Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn7Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn7Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近十年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return10Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn10Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn10Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return15Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn15Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn15Year)">%</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="returnInception"
        label="成立以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnInception | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnInception)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="categoryNameLocal"
        label="晨星分类"
        min-width="220"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="categoryGroupName"
        label="晨星分类组别"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="broadCategoryName_CN"
        label="晨星资产大类"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="ifOldestShare"
        label="是否最早份额"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifOldestShare) }}</template>
      </el-table-column>
      <el-table-column
        prop="ifPeerGroupMembershipChange"
        label="是否转型基金"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifPeerGroupMembershipChange) }}</template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import starrating0 from "../../public/images/smallstar0.gif";
import starrating1 from "../../public/images/smallstar1.gif";
import starrating2 from "../../public/images/smallstar2.gif";
import starrating3 from "../../public/images/smallstar3.gif";
import starrating4 from "../../public/images/smallstar4.gif";
import starrating5 from "../../public/images/smallstar5.gif";

import { Message } from "element-ui";
import { getFundRank } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;

const RANKING_CLOSE_MONTHLY_EXPORT_COLUMN_MAP_KEY = "rankingCloseMonthlyExportColumnMap";
const RANKING_CLOSE_MONTHLY_EXPORT_COLUMN_MAP = [
  { label: "基金代码", field: "defaultSymbol", valuePath: "scope.row.defaultSymbol" },
  { label: "基金名称", field: "legalName", valuePath: "scope.row.legalName" },
  { label: "成立日期", field: "inceptionDate", valuePath: "scope.row.inceptionDate" },
  { label: "净值日期", field: "priceDate", valuePath: "scope.row.priceDate" },
  { label: "单位净值|(元)", field: "nav", valuePath: "scope.row.nav" },
  { label: "今年以来|总回报率", field: "returnYTD", valuePath: "scope.row.returnYTD" },
  { label: "最近一周|总回报率", field: "return1Week", valuePath: "scope.row.return1Week" },
  { label: "最近一月|总回报率", field: "return1Month", valuePath: "scope.row.return1Month" },
  { label: "最近三月|总回报率", field: "return3Month", valuePath: "scope.row.return3Month" },
  { label: "最近六月|总回报率", field: "return6Month", valuePath: "scope.row.return6Month" },
  { label: "最近一年|总回报率", field: "return1Year", valuePath: "scope.row.return1Year" },
  { label: "最近两年|年化回报率", field: "return2Year", valuePath: "scope.row.return2Year" },
  { label: "最近两年|总回报率", field: "accReturn2Year", valuePath: "scope.row.accReturn2Year" },
  { label: "最近三年|年化回报率", field: "return3Year", valuePath: "scope.row.return3Year" },
  { label: "最近三年|总回报率", field: "accReturn3Year", valuePath: "scope.row.accReturn3Year" },
  { label: "最近五年|年化回报率", field: "return5Year", valuePath: "scope.row.return5Year" },
  { label: "最近五年|总回报率", field: "accReturn5Year", valuePath: "scope.row.accReturn5Year" },
  { label: "最近七年|年化回报率", field: "return7Year", valuePath: "scope.row.return7Year" },
  { label: "最近七年|总回报率", field: "accReturn7Year", valuePath: "scope.row.accReturn7Year" },
  { label: "最近十年|年化回报率", field: "return10Year", valuePath: "scope.row.return10Year" },
  { label: "最近十年|总回报率", field: "accReturn10Year", valuePath: "scope.row.accReturn10Year" },
  { label: "最近十五年|年化回报率", field: "return15Year", valuePath: "scope.row.return15Year" },
  { label: "最近十五年|总回报率", field: "accReturn15Year", valuePath: "scope.row.accReturn15Year" },
  { label: "成立以来|总回报率", field: "returnInception", valuePath: "scope.row.returnInception" },
  { label: "晨星分类", field: "categoryNameLocal", valuePath: "scope.row.categoryNameLocal" },
  { label: "晨星分类组别", field: "categoryGroupName", valuePath: "scope.row.categoryGroupName" },
  { label: "晨星资产大类", field: "broadCategoryName_CN", valuePath: "scope.row.broadCategoryName_CN" },
  { label: "是否最早份额", field: "ifOldestShare", valuePath: "scope.row.ifOldestShare" },
  { label: "是否转型基金", field: "ifPeerGroupMembershipChange", valuePath: "scope.row.ifPeerGroupMembershipChange" },
];

export default {
  props:{
      categories: {
        type: Array,
        default: []
      }
    },
    mixins: [loadingData],
    data() {
        return {
            activeTabLevl1:"l1-0",
            activeTabLevl2:["l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0"],
            activeTabLevl2Copy:["l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0"],
            dialogLoading: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                type: "CloseEnd",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "PriceDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeTabLevl1: function(val) {
        let indexL1 = this.getIndex(val);
        let indexL2 = this.getIndex(this.activeTabLevl2[indexL1]);
        this.loadingData(
                        this.categories[indexL1].categories[indexL2].id,
                        this.params.keyword,
                        this.params.date
                    );
        this.resetPaginationParameter();                   
      },

      activeTabLevl2: function(valNew) {
        let self = this;
        for (let i = 0; i < valNew.length; i++) {
　　　　　　　　if (self.activeTabLevl2Copy[i] != valNew[i]) {
　　　　　　　　　　let indexL1 = self.getIndex(self.activeTabLevl1);
                  let indexL2 = self.getIndex(valNew[i]);
                  self.loadingData(
                                  self.categories[indexL1].categories[indexL2].id,
                                  self.params.keyword,
                                  self.params.date
                              ); 
                  self.activeTabLevl2Copy = valNew.concat();
                  self.resetPaginationParameter();
                  break;
　　　　　　　　}
　　　　　　}
      },
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        },
    },
    mounted() {
        this.persistRankingCloseMonthlyExportColumnMap();
        /*const self = this;
        self.getData(self.params);*/
    },
    methods: {
      getRankingCloseMonthlyExportColumnMap() {
        return RANKING_CLOSE_MONTHLY_EXPORT_COLUMN_MAP;
      },
      persistRankingCloseMonthlyExportColumnMap() {
        setNameAndValue(RANKING_CLOSE_MONTHLY_EXPORT_COLUMN_MAP_KEY, RANKING_CLOSE_MONTHLY_EXPORT_COLUMN_MAP);
      },
      getIndex(strVal) {
        let posStart = strVal.indexOf('-');
        posStart+=1;
        return strVal.substring(posStart);
      },
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(categoryId, keyword, effectiveDate,flag) {
            const self = this;
            if (flag == 0){
              self.activeTabLevl2[0]="l2-0";
              self.activeTabLevl1 ="l1-0";
            }
            if (categoryId != null && categoryId != "") {
                self.params.categoryId = categoryId;
            }


            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
            } else {
                self.params.keyword = "";
            }

            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);
        },
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
.tableSpecial >>> table tr:nth-child(1) {
    line-height: 35px;
}

.tableSpecial >>> .col-divider-left {
    border-left: 1px solid #ebeef5 !important;
}
</style>
